import React from "react";
import { Digest } from "../../gql/types";
import DigestCard from "./DigestCard";
import DigestPlaceholderCard from "./DigestPlaceholderCard";
import StackedSwipeView from "../home/view/StackedSwipeView";

interface DigestStackedViewProps {
    triggerPrevSignal: number;
    setEnablePrevButton: (val: boolean) => void;
    digest: Digest | null;
}

const DigestStackedView: React.FC<DigestStackedViewProps> = ({ triggerPrevSignal, setEnablePrevButton, digest }) => {
    return (
        <StackedSwipeView
            items={digest?.sections.find(s => s.sectionType === "PRIORITY")?.items ?? []}
            triggerPrevSignal={triggerPrevSignal}
            setEnablePrevButton={setEnablePrevButton}
            renderCard={(item) => <DigestCard item={item} />}
            renderPlaceholder={() => <DigestPlaceholderCard />}
        />);

};

export default DigestStackedView;
